import { VEHICLE_REGISTRATION_METHOD } from "@shared/constants";

const isPostalCodeAllowed = (method, postalCode) => {
  if (!method?.allowedPostalCodesRegex) {
    return true;
  }
  if (!postalCode) {
    return true;
  }
  try {
    return new RegExp(method.allowedPostalCodesRegex).test(postalCode);
  } catch {
    return true;
  }
};

export const computeAvailableRegistrationMethods = (
  vehicleRegistration,
  postalCode,
  { isKeyAccount } = {}
) => {
  const { CITROEN, MYSELF } = VEHICLE_REGISTRATION_METHOD;
  const result = [];
  if (!vehicleRegistration) {
    return result;
  }

  const passes = method =>
    method?.enabled && isPostalCodeAllowed(method, postalCode);

  if (passes(vehicleRegistration.selfRegistration) && !isKeyAccount) {
    result.push({ ...vehicleRegistration.selfRegistration, method: MYSELF });
  }

  if (passes(vehicleRegistration.citroenRegistration)) {
    result.push({
      ...vehicleRegistration.citroenRegistration,
      method: CITROEN,
    });
  }

  return result;
};
